/* eslint-disable react/jsx-filename-extension */
import LoadingIndicator from 'components/LoadingIndicator';
import TextWithSubtext from 'components/TextWithSubtext';
import idx from 'idx';
import { capitalize } from 'lodash';
import React from 'react';
import { graphql } from 'react-apollo';
// @ts-ignore
import { Roles } from 'user/UserConstants';
import GET_ORG_MEMBER_QUERY from './queries/OrganizationMemberProfile.gql';

const UsersProfileOrgInfo = (props: any): JSX.Element => {
  const { member, currentRoles } = props;
  const { roles = [] } = member;
  const canViewRostered =
    currentRoles?.includes(Roles.ADMIN) || currentRoles?.includes(Roles.TEACHER);

  return (
    <div className="current-org-info">
      <TextWithSubtext
        subtext={roles.map(capitalize).join(', ')}
        subtle
        subtleTextColor="graphite"
        textSize="xsmall"
        subtextSize="xsmall"
        subtextColor="inherit">
        Role
      </TextWithSubtext>
      {member.grade && (
        <TextWithSubtext
          subtext={member.grade}
          subtle
          subtleTextColor="graphite"
          textSize="xsmall"
          subtextSize="xsmall"
          subtextColor="inherit">
          Grade
        </TextWithSubtext>
      )}
      {!currentRoles && <LoadingIndicator align="center" size="small" />}
      {canViewRostered && (
        <>
          <TextWithSubtext
            subtext={member.rosteredStatus ? 'SIS-linked' : 'Not SIS-linked'}
            subtle
            subtleTextColor="graphite"
            textSize="xsmall"
            subtextSize="xsmall"
            subtextColor="inherit">
            Membership
          </TextWithSubtext>

          {member.rosteredStatus && member.sisFirstName && (
            <TextWithSubtext
              subtext={`${member.sisFirstName ?? ''} ${member.sisLastName ?? ''}`}
              subtle
              subtleTextColor="graphite"
              textSize="xsmall"
              subtextSize="xsmall"
              subtextColor="inherit">
              SIS Name
            </TextWithSubtext>
          )}
        </>
      )}
    </div>
  );
};

const withOrganizationMember = graphql(GET_ORG_MEMBER_QUERY, {
  options: (props: any) => {
    const { entityUuid, currentUserId } = props;

    return {
      variables: {
        orgUuid: entityUuid,
        userId: currentUserId,
      },
      fetchPolicy: 'network-only',
    };
  },
  props: ({ data, ownProps }: any) => {
    const loadedMember = idx(data, _ => _.organizations[0].members.members[0]);
    const currentRoles = (() => {
      if (!data.loading && loadedMember) {
        return loadedMember?.roles;
      }
      return ownProps.currentRoles;
    })();

    return {
      organization: idx(data['organizations'], _ => _[0]),
      currentRoles,
      loading: data.loading,
      loaded: !!loadedMember,
      error: data.error,
      refetch: data.refetch,
    };
  },
  skip: ({ entityUuid }) => !entityUuid,
});

export default withOrganizationMember(UsersProfileOrgInfo);
